export const getters = {
  GET_LOADER: (state): boolean => state.loader,
  GET_RESET_PASSWORD_USER_EMAIL: (state): string => state.resetPasswordEmail,
  GET_EMAILS:(state)=>state.emails
}
